import axios from "axios";
import { bookingsBaseURL, getAllBookingsURLV2, getAllBookingsURLV3 } from "../../constants/apiUrl";

export const getAllBookingsV2 = async (startDate, endDate, listType, callbackFn) => {
  try {
    const response = await axios.request({
      baseURL: bookingsBaseURL,
      url: `${getAllBookingsURLV2}?periodFrom=${startDate}&periodTo=${endDate}&listType=${listType}`, //?periodFrom={{dateTimeFrom}}&periodTo={{dateTimeTo}}&listType={{listType}}&dataOffset={{dataStart}}&dataLimit={{dataSize}}
      method: 'get',
    });
    const bookings = [
      ...response?.data?.data
    ];
    callbackFn(bookings);
  }
  catch(e) {
    console.log('Something went wrong with pass templates fetching, please try again later.')
  }
};

export const getAllBookingsV3 = async (startDate, endDate, listType, dataOffset, dataLimit, customer, callbackFn) => {
  try {
    const headers = {
      'CustomerId': customer, // ✅ Set correct header name
    };

    const response = await axios.request({
      baseURL: bookingsBaseURL,
      url: `${getAllBookingsURLV3}?periodFrom=${startDate}&periodTo=${endDate}&listType=${listType}&dataOffset=${dataOffset}&dataLimit=${dataLimit}`,
      method: 'get',
      headers: headers,
    });

    // 🔍 Debugging - Log API response
    console.log("API Response:", response?.data);

    const bookings = response?.data?.data || [];
    callbackFn(bookings);
  }
  catch (error) {
    const errorData = {
      message: error?.response?.data || error?.response?.data?.message || 'Something went wrong with pass templates fetching, please try again later.',
      status: error?.response?.status,
    }
    callbackFn(errorData);
  }
};
